import * as actionTypes from './actionTypes';
import * as actions from './index';

const getUsersStart = () => {
    return {
        type: actionTypes.USER_GET_USERS_START
    };
};

const getUsersSuccess = (users) => {
    return {
        type: actionTypes.USER_GET_USERS_SUCCESS,
        payload: { users: users }
    };
};

const getUsersFail = (error) => {
    return {
        type: actionTypes.USER_GET_USERS_FAIL,
        error: error
    };
};

export const userGetUsers = () => {
    return dispatch => {
        dispatch(getUsersStart());
        window.flow.getUsersByFields().then((res) => {
            dispatch(getUsersSuccess(res.user.elements));
        }).catch(res => {
            console.log(res);
            dispatch(getUsersFail(res));
        })
    }
}
  
